import React from 'react';
import InputLabel from '../../../../components/base/InputLabel';
import IntegerInput from '../../../../components/base/IntegerInput';
import { MIN_VALUES } from '../../../../constants/minValues';
import BigNumber from 'bignumber.js';

const MatrixHeader = ({
    totalTrades,
    setTotalTrades,
    currentWinRate,
    setCurrentWinRate,
    maxDailyLosses,
    setMaxDailyLosses
}) => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-6 mb-6 sm:mb-8">
            <div className="w-full">
                <InputLabel>Total Trades</InputLabel>
                <IntegerInput
                    value={new BigNumber(totalTrades)}
                    onChange={value => setTotalTrades(value ? Number(value) : 0)}
                    min={MIN_VALUES.totalTrades}
                />
            </div>
            <div className="w-full">
                <InputLabel>Win Rate</InputLabel>
                <IntegerInput
                    value={new BigNumber(currentWinRate)}
                    onChange={value => setCurrentWinRate(value ? Number(value) : 0)}
                    suffix="%"
                    min={MIN_VALUES.winRate}
                />
            </div>
            <div className="w-full">
                <InputLabel>Max Daily Loss Streak</InputLabel>
                <IntegerInput
                    value={new BigNumber(maxDailyLosses)}
                    onChange={value => setMaxDailyLosses(value ? Number(value) : 0)}
                    min={MIN_VALUES.maxDailyLosses}
                />
            </div>
        </div>
    );
};

export default MatrixHeader;